import React from 'react';
import { Section } from './ui/Section';

export const WhyThis: React.FC = () => {
  return (
    <Section id="why" className="border-b border-gray-200/60">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-serif mb-10 text-primary">Why LeadFraud.org exists?</h2>
        <p className="text-xl text-secondary font-light leading-relaxed mb-16">
          B2B lead generation is full of quiet distortions: intent signals that never happened, consent that never existed, and volume metrics that obscure reality. Those distortions waste budget, poison trust between sales and marketing, and drive bad headcount and strategy decisions.
          <br /><br />
          LeadFraud.org exists to put an independent standard on top of all of it - to make it clear which leads are real and which vendors actually stand behind their numbers.
        </p>
        <div className="relative inline-block">
          <p className="text-3xl md:text-4xl font-serif italic text-primary leading-tight">
            Integrity isn’t a value here, it’s the operating system.
          </p>
        </div>
      </div>
    </Section>
  );
};